/** Build staff login email from display name + hospital slug. */

export function slugifyName(name) {
  return (name || '')
    .toLowerCase()
    .replace(/^dr\.?\s*/i, '')
    .trim()
    .split(/\s+/)[0]
    .replace(/[^a-z0-9]/g, '') || 'staff';
}

export function formatDoctorName(name) {
  const t = (name || '').trim();
  if (!t) return '';
  if (/^dr\.?\s/i.test(t)) return t;
  return `Dr. ${t}`;
}

export function suggestStaffEmail({ role, name, slug, index = 1 }) {
  const domain = slug ? `${slug}.hcen` : 'hospital.hcen';
  const base = slugifyName(name);
  if (role === 'doctor') return `dr.${base}@${domain}`;
  if (role === 'reception') return `reception${index}@${domain}`;
  if (role === 'pharmacy') return `pharmacy${index > 1 ? index : ''}@${domain}`.replace('pharmacy1@', 'pharmacy@');
  if (role === 'billing') return `billing@${domain}`;
  if (role === 'lab') return `lab@${domain}`;
  if (role === 'ipd') return `ipd@${domain}`;
  if (role === 'nurse') return `nurse${index > 1 ? index : ''}@${domain}`.replace('nurse1@', 'nurse@');
  if (role === 'hr') return `hr@${domain}`;
  if (role === 'manager') return `owner@${domain}`;
  return `${base}@${domain}`;
}

export function randomPassword(len = 10) {
  const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghjkmnpqrstuvwxyz23456789!@';
  let s = 'Hc';
  for (let i = 2; i < len; i++) s += chars[Math.floor(Math.random() * chars.length)];
  return s;
}
